WiseMetering.Model.IntegrationConfiguration = WiseMetering.Model.extend({
    urlRoot: '/integration_configurations',

    site: function() {
        return WiseMetering.zones.get(this.get('site_id'));
    },

    license: function() {
        return WiseMetering.integrationLicenses.get(this.get('license_id'));
    }
});
